/**
 * @generated SignedSource<<3e3b6def1d2f5354a1f7f5408ba5855a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroStatus_tradeFirm$data = {
  readonly rewards: {
    readonly currentProgram: {
      readonly programInfo: {
        readonly code: string | null;
        readonly shortCopy: string | null;
      } | null;
    } | null;
    readonly currentYearSpend: {
      readonly amount: number | null;
    } | null;
    readonly nextYearProgram: {
      readonly programInfo: {
        readonly code: string | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusProgressBar_rewards" | "rewardsStatusHelper_rewards">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusContact_tradeFirm">;
  readonly " $fragmentType": "TradeBenefitsHeroStatus_tradeFirm";
};
export type TradeBenefitsHeroStatus_tradeFirm$key = {
  readonly " $data"?: TradeBenefitsHeroStatus_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatus_tradeFirm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LoyaltyProgram",
    "kind": "LinkedField",
    "name": "programInfo",
    "plural": false,
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortCopy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ParentProgram",
  "kind": "LinkedField",
  "name": "currentProgram",
  "plural": false,
  "selections": (v1/*:: as any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroStatus_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ParentProgram",
          "kind": "LinkedField",
          "name": "nextYearProgram",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "currentYearSpend",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "rewardsStatusHelper_rewards",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pointsNeededToLevelUp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pointsToMaintainStatus",
              "storageKey": null
            },
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ParentProgram",
              "kind": "LinkedField",
              "name": "nextProgram",
              "plural": false,
              "selections": (v1/*:: as any*/),
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradeBenefitsHeroStatusProgressBar_rewards"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsHeroStatusContact_tradeFirm"
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
})();

(node as any).hash = "f2f978e2c0501801c1ac45015c2ce0ae";

export default node;
